import { GzProgressSpinnerWebComponent } from './component/GzProgressSpinnerWebComponent';
import { WEB_COMPONENT_GZ_PROGRESS_SPINNER } from '../../webcomponents.constants';

export { GzProgressSpinnerWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_PROGRESS_SPINNER, GzProgressSpinnerWebComponent);

/**
 *  Examples:
 *
 *  Default it will be size MEDIUM and indeterminate  => <gz-progress-spinner></gz-progress-spinner>
 *
 *  By setting a value on it will automatically turn to determined and
 *  it will get filled with the value => <gz-progress-spinner value="30"></gz-progress-spinner>
 *
 *  Spinner can take 3 sizes SMALL, MEDIUM and LARGE
 *  To change it's size you have to modify  spinnerwidth  property
 *
 *  Small spinner => <gz-progress-spinner spinnerwidth="small"></gz-progress-spinner>
 *  Medium spinner => <gz-progress-spinner spinnerwidth="medium"></gz-progress-spinner>
 *  Large spinner => <gz-progress-spinner spinnerwidth="large"></gz-progress-spinner>
 *
 */
